import { render } from "./FriendChatView.vue?vue&type=template&id=0a97558e&scoped=true"
import script from "./FriendChatView.vue?vue&type=script&lang=js"
export * from "./FriendChatView.vue?vue&type=script&lang=js"

import "./FriendChatView.vue?vue&type=style&index=0&id=0a97558e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a97558e"]])

export default __exports__